import { render } from "./uiTextInput.vue?vue&type=template&id=0b7452fa&ts=true"
import script from "./uiTextInput.vue?vue&type=script&lang=ts"
export * from "./uiTextInput.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\AttiTec\\DogToDo\\dev\\todo-list-vuejs-pwa-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__